module.exports = __webpack_public_path__ + "img/avatar4.6d6dee88.png";